const SIGNATURE = [137, 80, 78, 71, 13, 10, 26, 10];

// Tabla CRC32, polinomio reflejado 0xEDB88320: el mismo que define el estandar PNG.
const CRC_TABLE = (() => {
  const table = new Uint32Array(256);
  for (let n = 0; n < 256; n++) {
    let c = n;
    for (let k = 0; k < 8; k++) c = c & 1 ? 0xedb88320 ^ (c >>> 1) : c >>> 1;
    table[n] = c >>> 0;
  }
  return table;
})();

export function crc32(bytes) {
  let c = 0xffffffff;
  for (let i = 0; i < bytes.length; i++) c = CRC_TABLE[(c ^ bytes[i]) & 0xff] ^ (c >>> 8);
  return (c ^ 0xffffffff) >>> 0;
}

const u32 = (n) => [(n >>> 24) & 0xff, (n >>> 16) & 0xff, (n >>> 8) & 0xff, n & 0xff];

// Chunk completo: longitud(4) + tipo(4) + datos + CRC(4), donde el CRC cubre tipo+datos.
function buildChunk(type, data) {
  const body = new Uint8Array(4 + data.length);
  body.set([type.charCodeAt(0), type.charCodeAt(1), type.charCodeAt(2), type.charCodeAt(3)], 0);
  body.set(data, 4);
  const out = new Uint8Array(8 + data.length + 4);
  out.set(u32(data.length), 0);
  out.set(body, 4);
  out.set(u32(crc32(body)), 4 + body.length);
  return out;
}

// X px/m (4), Y px/m (4), unidad (1): 1 = metro. 11811 px/m = 300 ppi redondeado.
const physChunk = (ppm) => buildChunk('pHYs', new Uint8Array([...u32(ppm), ...u32(ppm), 1]));

// Devuelve un Uint8Array nuevo con el pHYs insertado antes del primer IDAT; descarta cualquier
// pHYs previo. No muta la entrada.
export function insertPhys(png, ppm = 11811) {
  const bytes = png instanceof Uint8Array ? png : new Uint8Array(png);
  for (let i = 0; i < 8; i++) {
    if (bytes[i] !== SIGNATURE[i]) throw new Error('No es un PNG valido');
  }
  const parts = [bytes.subarray(0, 8)];
  let inserted = false;
  let pos = 8;
  while (pos < bytes.length) {
    const len = ((bytes[pos] << 24) | (bytes[pos + 1] << 16) | (bytes[pos + 2] << 8) | bytes[pos + 3]) >>> 0;
    const type = String.fromCharCode(bytes[pos + 4], bytes[pos + 5], bytes[pos + 6], bytes[pos + 7]);
    const end = pos + 12 + len;
    if (type === 'pHYs') { pos = end; continue; }
    if (!inserted && (type === 'IDAT' || type === 'IEND')) {
      parts.push(physChunk(ppm));
      inserted = true;
    }
    parts.push(bytes.subarray(pos, end));
    pos = end;
  }
  if (!inserted) throw new Error('PNG sin IDAT');
  const out = new Uint8Array(parts.reduce((n, p) => n + p.length, 0));
  let off = 0;
  for (const p of parts) { out.set(p, off); off += p.length; }
  return out;
}
